import { extractStatusCode } from '~/utils/extractStatusCodeFromError';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('vue:error', (error: unknown) => {
        const statusCode = extractStatusCode(error);
        const isClientError = typeof statusCode === 'number' && statusCode >= 400 && statusCode < 500;
        const prefix = isClientError ? '[Vue Warning]' : '[Vue Error]';
        const logPayload = typeof statusCode === 'number' ? { statusCode, error } : error;

        if (isClientError) {
            console.warn(prefix, logPayload);
        } else {
            console.error(prefix, logPayload);
        }
    });
});
